/**
 * Clears session via `useAuth.logout` then replaces history to `/login`.
 *
 * Where: `/logout` route from sidebar/menu.
 * Uses: `useAuth`, `useNavigate`.
 * Behavior: runs once on mount; no UI beyond immediate redirect.
 */

import React, { useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { useNavigate } from 'react-router-dom';

export const Logout: React.FC = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    logout();
    navigate('/login', { replace: true });
  }, [logout, navigate]);

  return null;
}; 